<template>
  <vx-card no-shadow>
    <div class="flex items-end" v-if="showHeader">
      <feather-icon icon="LockIcon" class="mr-2" svgClasses="w-5 h-5" />
      <span class="leading-none font-medium">{{ $t('users.change_password') }}</span>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-2/3 w-full">
        <vs-input
          class="w-full mt-4"
          :label="$t('users.old_password')"
          v-validate="'required|min:8'"
          data-vv-validate-on="blur"
          :data-vv-as="$t('users.old_password')"
          v-model="oldPassword"
          name="oldPassword"
          type="password"
        />
        <span class="text-danger text-sm" v-show="errors.has('oldPassword')">{{
          errors.first('oldPassword')
        }}</span>

        <vs-input
          class="w-full mt-4"
          :label="$t('users.new_password')"
          v-validate="'required|min:8'"
          data-vv-validate-on="blur"
          :data-vv-as="$t('users.new_password')"
          ref="newPassword"
          v-model="newPassword"
          name="newPassword"
          type="password"
        />
        <span class="text-danger text-sm" v-show="errors.has('newPassword')">{{
          errors.first('newPassword')
        }}</span>

        <vs-input
          class="w-full mt-4"
          :label="$t('users.confirm_password')"
          v-validate="'required|confirmed:newPassword'"
          data-vv-validate-on="blur"
          :data-vv-as="$t('users.confirm_password')"
          v-model="confirmNewPassword"
          name="confirmNewPassword"
          type="password"
        />
        <span class="text-danger text-sm" v-show="errors.has('confirmNewPassword')">{{
          errors.first('confirmNewPassword')
        }}</span>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">{{
        $t('forms.update')
      }}</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">{{
        $t('forms.reset')
      }}</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmNewPassword: null
    }
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.oldPassword !== null &&
        this.newPassword !== null &&
        this.confirmNewPassword !== null
      )
    }
  },
  methods: {
    save_changes() {
      if (!this.validateForm) return
      this.$store
        .dispatch('auth/changePassword', { oldPassword: this.oldPassword, newPassword: this.newPassword })
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: this.$t('forms.successfully_edited')
          })
        })
    },
    reset_data() {
      this.oldPassword = null
      this.newPassword = null
      this.confirmNewPassword = null
    }
  }
}
</script>
